export enum EProjectDrawingRegisterSearchKey {
  DESIGNER = 'designer',
  KEYWORD = 'keyword',
}
